import type { CheckoutViews } from 'core';

type Steps = {
  [key: string]: number;
};

/**
 * Parse view object to enumerate the properties value of views
 *
 */
export function parseIndexViews(views: CheckoutViews) {
  const viewsKeys = Object.keys(views);
  const steps: Steps = {};

  viewsKeys.forEach((view, index) => {
    steps[view] = index + 1;

    return steps;
  });

  return steps;
}
